import React, { useEffect, useState } from 'react';
import './TimeslotPopup.css';
import { apiUrl } from '../config';

const overlap = (aStart, aEnd, bStart, bEnd) => (aStart < bEnd && aEnd > bStart);

const formatSelectedDate = (dateStr) => {
  if (!dateStr) return '';
  const [year, month, day] = dateStr.split('-').map(Number);
  if (!year || !month || !day) return dateStr;
  return new Date(year, month - 1, day).toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });
};

const TimeslotPopup = ({ dateStr, onSelect }) => {
  const [busy, setBusy] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!dateStr) return;
    setLoading(true);
    const start = new Date(dateStr + 'T00:00:00');
    const end = new Date(start);
    end.setDate(end.getDate() + 1);

    const timeMin = start.toISOString();
    const timeMax = end.toISOString();

    fetch(`${apiUrl('/api/google/calendar/busy')}?timeMin=${encodeURIComponent(timeMin)}&timeMax=${encodeURIComponent(timeMax)}`)
      .then(r => r.json())
      .then(data => {
        if (data && data.busy) setBusy(data.busy.map(b => ({ start: new Date(b.start), end: new Date(b.end) })));
      })
      .catch(err => console.error('Error fetching busy times', err))
      .finally(() => setLoading(false));
  }, [dateStr]);

  if (!dateStr) return null;

  const startOfDay = new Date(dateStr + 'T00:00:00');
  const slots = [];
  for (let i = 0; i < 48; i++) {
    const s = new Date(startOfDay.getTime() + i * 30 * 60 * 1000);
    const e = new Date(s.getTime() + 30 * 60 * 1000);
    const isBusy = busy.some(b => overlap(s, e, b.start, b.end));
    slots.push({ start: s, end: e, busy: isBusy });
  }

  return (
    <div className="timeslot-popup">
      <div className="timeslot-header">Available times for {formatSelectedDate(dateStr)}</div>
      {loading ? <div className="timeslot-loading">Loading...</div> : (
        <div className="timeslot-list">
          {slots.map((slot, idx) => (
            <div
              key={idx}
              className={slot.busy ? 'timeslot-item busy' : 'timeslot-item free'}
              onClick={() => !slot.busy && onSelect && onSelect(slot)}
            >
              <div className="timeslot-label">{slot.start.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} - {slot.end.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TimeslotPopup;
